module.exports = "/_next/static/images/customer-review-claudia@2x-min-c276c5ea779ac4b48dd279e5686eaafe.png";